import { del, get, post } from '../axios'
import { z } from 'zod'
import { StoreCompanyUserInput } from '../company/input/store-company-user-input'
import { CompanyRole } from '../company/company-role'
import { pendingInvitation } from './invitation'

export function fetchInvitations(companyId: string, role: CompanyRole) {
    return get(pendingInvitation.array(), `/companies/${companyId}/invitations?filter[role]=${role}`)
}

export function revokeInvitation(companyId: string, email: string) {
    return del(z.unknown(), `/companies/${companyId}/invitations/${encodeURIComponent(email)}`)
}

export function declineInvitation(companyId: string) {
    return post(z.string(), `/invitations/${companyId}/decline`, {})
}

export function acceptInvitation(companyId: string) {
    return post(z.string(), `/invitations/${companyId}/accept`, {})
}

export function sendInvitation(companyId: string, input: StoreCompanyUserInput) {
    return post(z.string(), `/companies/${companyId}/invite`, input)
}
